import * as $ from "jquery";
import ServiceREST from "../../Core/ServiceREST";
import { Notifications } from "../../Core/Notifications";
import Spinner from "../../Core/Spinner";

export default class PasswordResetRequestFormValidation extends ServiceREST
{
    readonly Selector: any;
    readonly view: string;
    spinner: typeof Spinner;

    constructor(spinner: typeof Spinner)
    {
        super();
        super.rest = this.rest.bind(this);
        this.validate = this.validate.bind(this)
        this.submit = this.submit.bind(this)
        this.Selector = {
            FORM: '#passwordResetRequestForm',
            SUBMIT_BUTTON: '#submitPasswordResetRequestForm',
            EMAIL_INPUT: '#accountEmail',
            SPINNER: '#password-reset-request-small-spinner'
        };
        this.spinner = spinner;
    }

    private getActiveForm(): JQuery<HTMLElement> {
        // Find the visible form (there may be multiple due to mobile/desktop headers)
        // Use attribute selector to get all elements with this ID (jQuery's #id only returns first)
        return $('[id="passwordResetRequestForm"]').filter(':visible').first();
    }

    public validate()
    {
        const $form = this.getActiveForm();
        if (!$form.length) return false;
        
        $form.on('submit', (e) => {
            e.preventDefault();
        }).validate({
            rules: {accountEmail : {required: true, email: true}},
            onclick: (element) => {
                $(element).valid();
            }
        });

        return $form.valid()
    }

    public async submit()
    {
        const $form = this.getActiveForm();
        if (!$form.length) return;
        
        const $emailInput = $form.find('[id="accountEmail"]');
        const $spinner = $form.find('[id="password-reset-request-small-spinner"]');
        
        let email:any = $emailInput.val();

        let url = $form.attr('data-api-url');

        url = url + email;

        if(this.validate()) {
            if(email.length > 0 ) {

                this.spinner.smallSpinner($spinner, true);

                let response = await this.rest('get', url);

                PasswordResetRequestFormValidation.notifications(response);

                this.spinner.smallSpinner($spinner, false);
            }
        }
    }

    private static notifications(response):void
    {
        if(response && response !== true){
            Notifications.add(response, 'error');
        }
    }

    public onClick()
    {
        $('body').on('click', this.Selector.SUBMIT_BUTTON, this.submit);
    }

    public onEnterPressed()
    {
        $('body').on('keypress', this.Selector.FORM, (e) => {
            if (e.keyCode == 13) {
                this.submit()
                e.preventDefault();
            }
        });
    }
}
const passwordResetRequestFormValidation = new PasswordResetRequestFormValidation(Spinner);

passwordResetRequestFormValidation.onClick();
passwordResetRequestFormValidation.onEnterPressed();
import * as $ from "jquery";
import ServiceREST from "../../Core/ServiceREST";
import { Notifications } from "../../Core/Notifications";
import Spinner from "../../Core/Spinner";

export default class PasswordResetRequestFormValidation extends ServiceREST
{
    readonly Selector: any;
    readonly view: string;
    spinner: typeof Spinner;

    constructor(spinner: typeof Spinner)
    {
        super();
        super.rest = this.rest.bind(this);
        this.validate = this.validate.bind(this)
        this.submit = this.submit.bind(this)
        this.Selector = {
            FORM: '#passwordResetRequestForm',
            SUBMIT_BUTTON: '#submitPasswordResetRequestForm',
            EMAIL_INPUT: '#accountEmail',
            SPINNER: '#password-reset-request-small-spinner'
        };
        this.spinner = spinner;
    }

    private getActiveForm(): JQuery<HTMLElement> {
        // Find the visible form (there may be multiple due to mobile/desktop headers)
        // Use attribute selector to get all elements with this ID (jQuery's #id only returns first)
        return $('[id="passwordResetRequestForm"]').filter(':visible').first();
    }

    public validate()
    {
        const $form = this.getActiveForm();
        if (!$form.length) return false;
        
        $form.on('submit', (e) => {
            e.preventDefault();
        }).validate({
            rules: {accountEmail : {required: true, email: true}},
            onclick: (element) => {
                $(element).valid();
            }
        });

        return $form.valid()
    }

    public async submit()
    {
        const $form = this.getActiveForm();
        if (!$form.length) return;
        
        const $emailInput = $form.find('[id="accountEmail"]');
        const $spinner = $form.find('[id="password-reset-request-small-spinner"]');
        
        let email:any = $emailInput.val();

        let url = $form.attr('data-api-url');

        url = url + email;

        if(this.validate()) {
            if(email.length > 0 ) {

                this.spinner.smallSpinner($spinner, true);

                let response = await this.rest('get', url);

                PasswordResetRequestFormValidation.notifications(response);

                this.spinner.smallSpinner($spinner, false);
            }
        }
    }

    private static notifications(response):void
    {
        if(response && response !== true){
            Notifications.add(response, 'error');
        }
    }

    public onClick()
    {
        $('body').on('click', this.Selector.SUBMIT_BUTTON, this.submit);
    }

    public onEnterPressed()
    {
        $('body').on('keypress', this.Selector.FORM, (e) => {
            if (e.keyCode == 13) {
                this.submit()
                e.preventDefault();
            }
        });
    }
}
const passwordResetRequestFormValidation = new PasswordResetRequestFormValidation(Spinner);

passwordResetRequestFormValidation.onClick();
passwordResetRequestFormValidation.onEnterPressed();
